import {
    Autocomplete,
    Box, Button,
    Card, CardActions,
    CardContent,
    CardHeader, IconButton,
    InputAdornment,
    Table,
    TableBody,
    TableCell, TableContainer,
    TableHead,
    TableRow,
    TextField,
} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../store";
import {useEffect, useState} from "react";
import moment from "moment";
import {getDashboardFielderClaim} from "../dashboard.api";
import CustomDatePicker from "../../../shared/customDatePicker/CustomDatePicker";
import {formatName} from "../../../shared/utils";
import {Close, Description, Search} from "@mui/icons-material";
import Papa from "papaparse"
import {getAccountFielder} from "../../account/account.api";
import {setParameterGetData} from "../../project/project.reducer";

export default function DashboardFielderClaim() {

    const dispatch = useDispatch<any>()

    const {dataFielderClaims} = useSelector((state: RootState) => state.dashboard)
    const {dataFielderList} = useSelector((state: RootState) => state.account)

    // delaying input search
    const [timer, setTimer] = useState(setTimeout(() => {
    }, 1000));

    const [filter, setFilter] = useState<string | undefined>("")
    const [searchText, setSearchText] = useState<string>("")
    const [dateStart, setDateStart] = useState(moment().add(-7, 'days').format('YYYY-MM-DD'))
    const [dateEnd, setDateEnd] = useState(moment().format('YYYY-MM-DD'))
    const [fielderIdSelected, setFielderIdSelected] = useState<string | undefined>(undefined)

    useEffect(() => {
        dispatch(getAccountFielder())
    }, [dispatch])

    useEffect(() => {
                dispatch(getDashboardFielderClaim({
                    filterStartDate: dateStart,
                    filterEndDate: dateEnd,
                    filter: filter,
                    fielderId: fielderIdSelected || "",
                }))

    }, [dispatch, dateStart, dateEnd, fielderIdSelected, filter])

    // const handleExportCsv = () => {
    //     const csvData = dataManagerLogs.map((item) => ({
    //         Project: item.project,
    //         Request: item.fieldingRequest,
    //         AssignedFielder: item.assignedFielder,
    //         FieldingType: item.fieldingType,
    //         Poles: item.poles,
    //         Frontyard: item.frontyard,
    //         Backyard: item.backyard,
    //         NoAccessPoles: item.noAccessPole,
    //         Underground: item.underground,
    //         structures: item.structures,
    //         NoAccessStructures: item.noAccessStructures,
    //         StructuresNotInField: item.structuresNotInField,
    //         CompleteDate: item.date,
    //     }));
    //     const csvString = Papa.unparse(csvData, {header: true});
    //     const blob = new Blob([csvString], {type: 'text/csv;charset=utf-8;'});
    //     const url = URL.createObjectURL(blob);
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.download = `manager logs ${moment(dateStart).format('YYYY-MM-DD')} - ${moment(dateEnd).format('YYYY-MM-DD')}.csv`;
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // }

    const dataSorted = [...dataFielderClaims].sort((a, b) => moment(b.sortDate).diff(moment(a.sortDate)))

    const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
        clearTimeout(timer);
        setTimer(
            setTimeout(() => {
                setFilter(e.target.value);
            }, 1000)
        );
    }

    return (
        <Card variant="outlined">
            <CardHeader
                sx={{borderBottom: '1px solid rgba(224, 224, 224, 1)'}}
                title="Fielder's Claim to Work"
                action={(
                    <Box display={"flex"} flexWrap={"wrap"} justifyContent={"flex-end"} gap={1}>
                        <Autocomplete
                            sx={{width: 200}}
                            options={dataFielderList}
                            getOptionLabel={(value: { id: string, fullName: string }) => formatName(value.fullName)}
                            onChange={(e, value) => setFielderIdSelected(value?.id || '')}
                            value={dataFielderList.find((data) => data.id === fielderIdSelected)}
                            renderInput={(params) => <TextField {...params} label="Filter Fielder"/>}
                        />
                        <TextField
                            label='Project'
                            sx={{width: 200}}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position='start'>
                                        <Search/>
                                    </InputAdornment>
                                ),
                                endAdornment:
                                    searchText !== "" ? (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => {
                                                    setFilter("")
                                                    setSearchText("")
                                                }}
                                            >
                                                <Close />
                                            </IconButton>
                                        </InputAdornment>
                                    ) : undefined
                            }}
                            value={searchText}
                            onChange={onSearchChange}
                        />
                        <CustomDatePicker dateStart={dateStart} dateEnd={dateEnd} setDateStart={setDateStart}
                                          setDateEnd={setDateEnd}/>
                    </Box>
                )}
            />
            <CardContent>
                <TableContainer sx={{height: 400}}>
                    <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>Project</TableCell>
                            <TableCell>Fielding Request</TableCell>
                            <TableCell>Total Req</TableCell>
                            <TableCell>Fielder Name</TableCell>
                            <TableCell>Claim Date</TableCell>
                            <TableCell>Assign Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataFielderClaims.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>{item.project}</TableCell>
                                <TableCell sx={{whiteSpace: "nowrap"}}>{item.fieldingRequest}</TableCell>
                                <TableCell>{item.totalMarkerRequest}</TableCell>
                                <TableCell>{item.fielderName}</TableCell>
                                <TableCell>{item.claimDateString}</TableCell>
                                <TableCell>{item.assignDateString}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                </TableContainer>
            </CardContent>
            {/*<CardActions>*/}
            {/*    <Box marginTop={2}>*/}
            {/*        <Button startIcon={<Description />} onClick={handleExportCsv}>*/}
            {/*            Export to CSV*/}
            {/*        </Button>*/}
            {/*    </Box>*/}
            {/*</CardActions>*/}
        </Card>
    )
}